import { Link } from "react-router-dom";
import React from "react";
import PropTypes from "prop-types";
import useDefaultRoutePath from "src/app/Restricted/useDefaultRoutePath";

const HomeLink = ({ children, item, className }) => {
  const defaultRoutePath = useDefaultRoutePath();
  return (
    <Link to={defaultRoutePath} aria-label={item.name} className={className}>
      {children}
    </Link>
  );
};
HomeLink.propTypes = {
  item: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default HomeLink;
